import { TipoFreteDisponivel } from "./tipos";

export const ordenarTiposFrete = (tipoFrete1: TipoFreteDisponivel, tipoFrete2: TipoFreteDisponivel) => tipoFrete1.Descricao.localeCompare(tipoFrete2.Descricao)